module.exports = __webpack_public_path__ + "static/media/collage_fines.eb60f6ff.jpg";